// Hints describing non-obvious quantity calculations so we can surface
// them in tooltips next to numbers. Keys are [room_type][item_name].

export const ROOM_ITEM_HINTS = {
  bathroom: {
    Tiling:
      "Qty = size × 2.5 — covers floor + full-height wall tiling, which is the norm for wet areas.",
    Waterproofing:
      "Qty = size × 1.2 — waterproofing membrane covers the floor plus a lip up each wall.",
    Paint:
      "Qty = size × 2.5 — paintable wall + ceiling area above the tile line.",
  },
  kitchen: {
    Cabinetry:
      "Qty = max(4, size × 0.8) linear metres — estimates typical base + tall cabinet run.",
    Benchtop:
      "Qty = max(3, size × 0.6) linear metres — counter + island run.",
    Splashback:
      "Qty = size × 0.6 — typical area of tiled splashback behind the benchtop.",
    Paint:
      "Qty = size × 2.8 — wall + ceiling area minus cabinetry.",
    Flooring:
      "Qty = size (sqm) — flat coverage of the kitchen footprint.",
  },
  bedroom: {
    Paint:
      "Qty = size × 3 — wall + ceiling surface area in a standard bedroom.",
    Flooring: "Qty = size (sqm) — flat coverage of the bedroom footprint.",
    Wardrobe:
      "Qty = max(2, size × 0.2) linear metres — typical built-in wardrobe run.",
  },
  lounge: {
    Paint:
      "Qty = size × 2.8 — wall + ceiling area. Vaulted ceilings may need manual adjustment.",
    "Skirting/Trim":
      "Qty ≈ √size × 4 linear metres — approximates the perimeter of the room.",
    Flooring: "Qty = size (sqm) — flat coverage of the lounge footprint.",
  },
  laundry: {
    Tiling: "Qty = size × 1.5 — floor + half-height splash zone.",
    Paint: "Qty = size × 2.2 — wall + ceiling area above tiles.",
  },
  hallway: {
    Paint:
      "Qty = size × 3 — narrow rooms have more wall area per square metre.",
  },
  dining: {
    Paint: "Qty = size × 2.8 — wall + ceiling area.",
  },
  office: {
    Paint: "Qty = size × 2.8 — wall + ceiling area.",
  },
  other: {
    Paint:
      "Qty = size × 2.8 — rough wall + ceiling area. Tune if the space is unusually tall or open.",
  },
};

/**
 * Return a hint string for a given room-type + work-item name, or null.
 */
export function getRoomItemHint(roomType, itemName) {
  const t = ROOM_ITEM_HINTS[roomType] || {};
  return t[itemName] || null;
}

/**
 * Human-readable description of the Exterior/Systems scope multiplier.
 */
export function scopeMultiplierHint(scope) {
  const map = {
    repair: "0.4× — patch and restore the existing item, not replace it.",
    replace: "1.0× — standard replacement cost.",
    upgrade: "1.4× — upgraded spec, better materials or finish.",
  };
  return map[scope] || null;
}

/**
 * Finish-level multiplier applied to base rates in room templates.
 */
export const FINISH_HINT = {
  budget: "Budget finish — base rates × 0.7.",
  mid: "Mid finish — base rates × 1.0 (default).",
  premium: "Premium finish — base rates × 1.6.",
};
